export default "__VITE_ASSET__982e5501__"